import React, { Component } from 'react';
import Select from 'react-select';
import '../../../css/responsive.css'
class ResumeTrComponent extends Component {
    render() {
        const { filter, onChangeFilter, searchData, drivers, transports } = this.props;
        const statusOp = [{ value: 'A', label: 'Todos' }, { value: 'V', label: 'Válido' }, { value: 'I', label: 'Inválido' }]
        return (
            <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
                {/* <div className="form-group d-flex align-items-center mb-2 mr-3 ml-3" style={{ minWidth: 240 }}>
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Buscar por:</span>
                    </div>
                    <Select
                        options={duplicatedFilter}
                        value={duplicatedFilter.find(b => b.value === filter?.duplicated ?? null) || null}
                        // onChange={(e) => onChangeFilter('duplicated', e.value)}
                        isDisabled={true}
                        placeholder="Buscar por..."
                        isSearchable
                        isClearable
                        menuPortalTarget={document.body}
                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                        styles={{
                            container: (base) => ({ ...base, flex: 1, width: 200 }),
                            control: (base) => ({ ...base, height: 39, minHeight: 39, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                            singleValue: (base) => ({ ...base, color: "#000" })
                        }}
                    />
                </div> */}
                <div className="form-group d-flex align-items-center mb-2 mr-3 ml-3" style={{ minWidth: 240 }}>
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Estatus:</span>
                    </div>
                    <Select
                        options={statusOp ?? []}
                        value={statusOp?.find(b => b.value === filter?.status ?? null) || null}
                        onChange={(e) => onChangeFilter('status', e?.value ?? null)}
                        placeholder="Estatus..."
                        isSearchable
                        isClearable
                        menuPortalTarget={document.body}
                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                        styles={{
                            container: (base) => ({ ...base, flex: 1, width: 200 }),
                            control: (base) => ({ ...base, height: 39, minHeight: 39, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                            singleValue: (base) => ({ ...base, color: "#000" })
                        }}
                    />
                </div>
                {(filter?.duplicated ?? null) === 'OP' &&
                    <div className="form-group d-flex align-items-center mb-2 mr-3 ml-3" style={{ minWidth: 240 }}>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Operadores:</span>
                        </div>
                        <Select
                            options={drivers ?? []}
                            value={drivers?.find(b => b.value === filter?.driver ?? null) || null}
                            onChange={(e) => onChangeFilter('driver', e?.value ?? null)}
                            placeholder="Operador..."
                            isSearchable
                            isClearable
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1, width: 200 }),
                                control: (base) => ({ ...base, height: 39, minHeight: 39, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div>
                }
                {(filter?.duplicated ?? null) === 'TR' &&
                    <div className="form-group d-flex align-items-center mb-2 mr-3 ml-3" style={{ minWidth: 240 }}>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Transportes:</span>
                        </div>
                        <Select
                            options={transports ?? []}
                            value={transports?.find(b => b.value === filter?.transport ?? null) || null}
                            onChange={(e) => onChangeFilter('transport', e?.value ?? null)}
                            placeholder="Transporte..."
                            isSearchable
                            isClearable
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1, width: 200 }),
                                control: (base) => ({ ...base, height: 39, minHeight: 39, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div>
                }
                <div className="form-group d-flex align-items-center mb-2 mr-3 btn-buscar" style={{ minWidth: 240 }}>
                    <button className="btn btn-active" data-toggle="tooltip" data-placement="top"
                        title={'Buscar'}
                        onClick={searchData}>
                        <i className="fas fa-search"></i>
                    </button>
                </div>
            </div>
        );
    }
}

export default ResumeTrComponent;
